import { type GlobalLocation } from '@/lib/apollo/locationCache'

export const areLocationsEquivalent = (
  previousLocation: GlobalLocation,
  newLocation: GlobalLocation
): boolean => {
  return Object.keys(newLocation).every((locationProperty) => {
    if (locationProperty === 'name') {
      const newLocationName = newLocation['name']
      const previousLocationName = previousLocation['name']

      return newLocationName?.en_CA === previousLocationName?.en_CA
    }

    return (
      newLocation[locationProperty as keyof GlobalLocation] ===
      previousLocation[locationProperty as keyof GlobalLocation]
    )
  })
}
